import styled from '@emotion/styled';
import type { NMRiumData } from 'nmrium';
import { Button } from 'react-science/ui';

import NMRiumWrapper from '../NMRiumWrapper.js';
import events from '../events/event.js';
import { loadFilesFromURLs } from '../utilities/loadFilesFromURLs.js';

import qmSignalsData from './data/qm-signals.json' with { type: 'json' };
import jsonData from './data/test.json' with { type: 'json' };

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Header = styled.div`
  height: 40px;
  width: 100%;
  padding: 5px;
  display: flex;
`;

export default function NMRiumWrapperDemo() {
  return (
    <Container>
      <Header>
        <Button
          style={{ marginRight: '10px' }}
          onClick={() => {
            events.trigger('load', {
              data: jsonData as unknown as NMRiumData,
              type: 'nmrium',
            });
          }}
          intent="primary"
        >
          Test load from json
        </Button>

        <Button
          style={{ marginRight: '10px' }}
          onClick={() => {
            events.trigger('load', {
              data: [
                'https://cheminfo.github.io/nmr-dataset-demo/cytisine/13c.jdx',
                'https://cheminfo.github.io/nmr-dataset-demo/cytisine/1h.jdx',
                'https://cheminfo.github.io/bruker-data-test/data/zipped/aspirin-1h.zip',
                // '../data/13c.zip',
                // 'https://cloud.uni-jena.de/s/y72GbCX8bJbmpJT/download/10.zip',
                // 'https://cloud.uni-jena.de/s/jsMed9fmqWZzo6r/download/53.zip',
              ],
              type: 'url',
              activeTab: '13C',
            });
          }}
        >
          Test Load from URLS
        </Button>

        <Button
          style={{ marginRight: '10px' }}
          onClick={() => {
            events.trigger('load', {
              data: [
                'https://cheminfo.github.io/bruker-data-test/data/zipped/aspirin-1h',
              ],
              type: 'url',
            });
          }}
        >
          Test Load URL without extension
        </Button>
        <Button
          style={{ marginRight: '10px' }}
          onClick={() => {
            void loadFilesFromURLs([
              '../data/COSY-12.zip',
              '../data/HMBC-13.zip',
              '../data/13c.zip',
            ]).then((files) => {
              events.trigger('load', {
                data: files,
                type: 'file',
                activeTab: '13C',
              });
            });
          }}
        >
          Test Load Files
        </Button>
        <Button
          className="logger-btn"
          onClick={() => {
            void loadFilesFromURLs(['../data/sample-with-error.zip']).then(
              (files) => {
                events.trigger('load', {
                  data: files,
                  type: 'file',
                  activeTab: '13C',
                });
              },
            );
          }}
        >
          Test Logger
        </Button>
        <Button
          className="load-qm-signals-btn"
          style={{ marginRight: '10px' }}
          onClick={() => {
            events.trigger('load', {
              data: qmSignalsData as unknown as NMRiumData,
              type: 'nmrium',
            });
          }}
        >
          Test load QM signals
        </Button>
        <Button
          className="highlight-signal-btn"
          style={{ marginRight: '10px' }}
          onClick={() => {
            events.trigger('action-request', {
              type: 'highlight',
              params: {
                ids: ['qm-signal-1H-7-8', 'qm-range-1H-7-8', 'qm-1H-7-8'],
              },
            });
          }}
        >
          Test highlight signal
        </Button>
        <Button
          className="clear-highlight-btn"
          onClick={() => {
            events.trigger('action-request', {
              type: 'clearHighlight',
            });
          }}
        >
          Clear highlight
        </Button>
      </Header>

      <NMRiumWrapper />
    </Container>
  );
}
